import { createFileRoute, redirect } from '@tanstack/react-router'

// Prototype: open straight into the app — no public landing page.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
  component: () => null,
})
